
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.655 5.427a.973.973 0 01-.71-.304L4.293 3.43a1.065 1.065 0 010-1.48.989.989 0 011.423 0l1.64 1.695a1.065 1.065 0 010 1.48.952.952 0 01-.702.303zM13.76 5.427a.973.973 0 01-.712-.304 1.062 1.062 0 01-.294-.744c0-.284.104-.539.294-.735l1.64-1.695a.989.989 0 011.423 0 1.065 1.065 0 010 1.48l-1.64 1.694a.973.973 0 01-.712.304zM8.903 4.3a1 1 0 01-.93-.646l-.89-2.214a1.07 1.07 0 010-.803A1.012 1.012 0 018.012 0a1 1 0 01.928.647l.882 2.213a1.07 1.07 0 010 .804.977.977 0 01-.92.636zM11.511 4.3a1.06 1.06 0 01-.388-.078c-.513-.215-.76-.833-.55-1.362l.881-2.213c.171-.392.532-.647.949-.647.133 0 .256.03.38.078.511.226.758.833.55 1.362l-.892 2.214a1 1 0 01-.93.646zM11.758 24c-3.974 0-7.199-3.34-7.199-7.435V13.38c0-1.46 1.148-2.645 2.561-2.645.18 0 .36.02.54.06V8.051c0-1.46 1.148-2.645 2.562-2.645 1.413 0 2.56 1.186 2.56 2.645v2.684h3.633c1.973 0 3.585 1.656 3.585 3.693l-.01.128-.01.088-1.545 8.003c-.095.49-.512.843-.986.843-.067 0-.133-.01-.2-.02a1.047 1.047 0 01-.644-.44c-.152-.236-.2-.51-.152-.784l1.527-7.916a1.584 1.584 0 00-1.575-1.498h-4.647l-.104-.01-.114-.02-.095-.03-.095-.038-.17-.098-.086-.069L11 12.47l-.057-.068-.047-.079-.047-.088-.039-.098-.028-.088-.019-.118-.01-.097V8.052a.55.55 0 00-.54-.558.55.55 0 00-.54.558v8.523c0 .578-.456 1.048-1.015 1.048-.56 0-1.015-.47-1.015-1.048V13.38a.55.55 0 00-.54-.558.543.543 0 00-.541.558v3.184c0 2.948 2.323 5.348 5.178 5.348.56 0 1.015.47 1.015 1.049 0 .578-.446 1.038-.996 1.038z","fill":"currentColor"}})])
          )
        }
      }
    